
import Axios from "axios";
import ManagerLocalStorage from "@/utils/managerLocalStorage.js";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";

import Store from "@/store/index.js";
const domain = Store.state.domain;

export default {
    
    serviceWorkerStart() {
        if (navigator.serviceWorker) {
            navigator.serviceWorker.register('/serviceWorker.min.js').
                then(function (reg) {
                    console.log(reg);
                }).catch(function (error) {
                    console.log(error);
                });
            navigator.serviceWorker.ready.then(function (registration) {
                registration.active.postMessage({
                    "command": "SignOut",
                    "action": true
                });
            });
        }
    },
    
    
    verifyLogin(user) {
        var formData = new FormData();
        formData.append("username", user.username);
        formData.append("password", user.password);



        return Axios.post(`${domain.domainNameWithHttp}/LoginInicio`, formData);
    },

    signOff(domainNameForApi, informationPage){
        Axios.post(`${domainNameForApi}signOut`)
            .then((response) => {
                if(response.data){
                    ManagerLocalStorage.removeLocalStorage(informationPage.nameLocalStoragePGV2);
                    MetodosGenerales.eliminaCookie(informationPage.nameCookiePGV2);
                    setTimeout(() => {
                        location.reload()
                    }, 100);
                };
            }).catch((error) => {
                console.log(error);
            });
    },

    IntentosRecuperarPass(vm, data) {
        return Axios.post(`${domain.domainNameWithHttp}/IntentosRecuperarPass`, data).then(response => response.data);
    },
    BloqueRecuperar(data) {
        return Axios.post(`${domain.domainNameWithHttp}/BloqueRecuperar`, data).then(response => response.data);
    }
}